<div class="container-color main-container">
  <div class="report-list-header rr-container-white">
    <div class="report-controls">
      <div class="d-flex flex-wrap flex-column flex-lg-row justify-content-center align-items-center pb-3">
        <!--ALL/FAVORITES VIEW-->
        <div class="pb-2 d-flex align-items-center" *ngIf="availableDashboards.length > 1">
          <div class="btn-group" role="button">
            <button class="btn fw-700" type="button" (click)="changeGroupView('all')" [class.btn-primary]="groupView == 'all'" [class.btn-outline-secondary]="groupView != 'all'">All Reports</button>
            <button class="btn fw-700" type="button" (click)="changeGroupView('favorites')" [class.btn-primary]="groupView == 'favorites'" [class.btn-outline-secondary]="groupView != 'favorites'">
              <i [class.fas]="groupView == 'favorites'" [class.far]="groupView != 'favorites'" class="fa-star"></i>
              Favorites
            </button>
          </div>
        </div>

        <!--SEARCH BAR-->
        <p-iconField iconPosition="left" class="pb-2">
          <p-inputIcon styleClass="pi pi-search" />
          <input type="text" pInputText placeholder="Filter by dashboard" trim="blur" name="reportQuery" [(ngModel)]="filters.reportQuery" style="min-width: 25vw;" />
        </p-iconField>

        <!--GALLERY/LIST BUTTONS-->
        <div *ngIf="availableDashboards.length > 1" class="d-flex align-items-center pb-2" style="width: 175px;">
          <div class="btn-group" role="button">
            <button class="btn btn-sm" [class.btn-outline-dark]="listDisplay" [class.btn-dark]="!listDisplay" (click)="swapViews(false)" title="Gallery view"><i class="fas fa-th-large pr-2"></i>Groups</button>
            <button class="btn btn-sm" [class.btn-outline-dark]="!listDisplay" [class.btn-dark]="listDisplay" (click)="swapViews(true)" title="List view"><i class="fas fa-bars pr-2"></i>List</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="rr-container-color">
    <div *ngIf="isLoading" class="py-4">
      <app-loading-indicator [large]="true" [message]="'Loading dashboards...'"></app-loading-indicator>
    </div>

    <div class="error-container" *ngIf="errorRetrievingDashboards" style="text-align: center; padding: 4em 1em">
      <h5><strong>An error has occurred with your session. Please <a routerLink="/logout">sign out</a> and login again.</strong></h5>
      <p>If this problem persists, please contact the <a href="mailto:support@mi4.com?Subject=Portal%20Issue">Mi4 Support Team.</a></p>
    </div>

    <div class="error-container" *ngIf="noDashboardsReceived || !showDashboards" style="text-align: center; padding: 4em 1em">
      <div class="py-4">
        <img src="/assets/no-dashboard-img.svg" alt="No dashboards image" style="height: 125px;" />
      </div>
      <h5><strong>You are not currently authorized to view any dashboards.</strong></h5>
      <p>Please contact the <a href="mailto:support@mi4.com">Mi4 Support Team</a> or your administrator to request access to dashboards.</p>
    </div>

    <div *ngIf="!isLoading && !noDashboardsReceived && !errorRetrievingDashboards && showDashboards">
      <div class="px-2">
        <div class="">
          <div class="rr-elevation-z2 table-responsive">
            <table class="table table-hover rr-table">
              <thead class="rr-table-header">
                <tr>
                  <th class="text-nowrap" style="width: 60%;">
                    Dashboard
                    <span class="pl-1 pointer-cursor" title="Sort" *ngIf="dashboardsSort.reportName"><i class="fas fa-sort-amount-up-alt" (click)="sortReportsBy('reportName')"></i></span>
                    <span *ngIf="!dashboardsSort.reportName" class="pl-1 pointer-cursor" title="Sort"><i class="fas fa-sort-amount-down" (click)="sortReportsBy('reportName')"></i></span>
                  </th>
                  <th class="text-nowrap" style="width: 40%;">
                    Group
                  </th>
                </tr>
              </thead>
              <tbody>
                <ng-container *ngFor="let dashboardGroup of availableDashboards">
                  <tr *ngFor="let dashboard of dashboardGroup.reports | reportQueryFilter: filters.reportQuery | reportSortBy: sortColumn : sortDesc | paginate: { itemsPerPage: paginatePerPage, currentPage: p1, id: 'reportsPaginate' }; index as i">
                    <td>
                      <a [routerLink]="['../dashboard/view']" [queryParams]="{ reportId: dashboard.biReportID, groupId: dashboard.biGroupID, datasetId: dashboard.biDatasetID }" target="_blank">
                        <span style="font-size: 1.15em;"><strong>{{dashboard.reportName}}</strong></span>
                        <p class="mb-0 no-under-hover" style="font-weight: 500;"><em class="text-muted no-under-hover">{{dashboard.reportDescription}}</em></p>
                      </a>
                    </td>
                    <td>
                      <span class="badge badge-dark" style="font-size: 100%;">{{dashboard.reportGroup}}</span>
                    </td>
                  </tr>
                  <tr *ngIf="(dashboardGroup.reports | reportQueryFilter: filters.reportQuery).length == 0" class="text-center ignore-hover">
                    <td colspan="2"><em>No dashboards matching filters found</em></td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
            <div class="rr-table-footer d-flex flex-wrap flex-column flex-sm-row justify-content-between align-items-center bg-white p-2">
              <div style="font-size: 0.8em">
                <span class="text-muted">Total: {{ (availableDashboards[0].reports | reportQueryFilter: filters.reportQuery).length }}</span>
              </div>
              <div class="text-center py-2 py-md-0" style="font-size: 0.9em">
                <pagination-controls (pageChange)="p1 = $event" id="reportsPaginate"></pagination-controls>
              </div>
              <div class="">
                <div class="input-group input-group-sm" style="font-size: 0.9em">
                  <div class="input-group-prepend">
                    <label class="input-group-text" style="font-size: 0.9em" for="paginatePerPage">Per Page: </label>
                  </div>
                  <select class="form-control" [(ngModel)]="paginatePerPage" style="font-size: 0.9em">
                    <option value="12">12</option>
                    <option value="24">24</option>
                    <option value="48">48</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!--<scroll-to-top-btn></scroll-to-top-btn>-->
</div>
